import React, { useCallback, useEffect, useMemo, useRef } from 'react';

import { downloadSettingExcel } from "src/utils/blob/blobUtil";


import { defaultPUR6010_R01Filter, PUR6010_R01Filter, usePUR6010_R01Store } from 'src/containers/mes/PUR/PUR6010_R01/Store_PUR6010_R01';
import useFetchActionbarAuth from 'src/hooks/useFetchActionbarAuth';
import { Tab } from 'src/store/useUiuxStore';
import { useLoadingSpinnerStore } from 'src/store/util/loadingSpinnerUtil';
import { showError, showSuccess, ShowSuccessFetch, showWarning } from 'src/utils/toast/toastUtil';

import { AgGridReact } from 'ag-grid-react';
import { useCommonCodeStore } from 'src/store/useCommonCodeStore';
import { fetchDataSetHandler, fetchFilterConfig, gridRefSelectedRowHandler } from 'src/utils/grid/GridHandlerContent';
import { refetchUpdateList } from 'src/utils/axios/reFetch';
import { deletePUR6010_R01, downloadExcel_PUR6010_R01, getPUR6010_R01AllCount, getPUR6010_R01CreateDetailList, getPUR6010_R01DetailList, getPUR6010_R01List, getPUR6010_R01One, patchPUR6010_R01, postPUR6010_R01 } from "./Api_PUR6010_R01";
import { defaultPUR6010_R01DetailDto, defaultPUR6010_R01HeaderDto, PUR6010_R01DetailDto, PUR6010_R01Dto, PUR6010_R01HeaderDto } from './Dto_PUR6010_R01';
import { formatDateYYYYMMDD, validateString } from 'src/utils/string/stringUtil';
import { validateCustomCd, validateEmployeeCd } from 'src/utils/grid/GridValidateContent';

interface Props {
	gridRef: React.RefObject<AgGridReact<PUR6010_R01HeaderDto> | null>;
	detailGridRef: React.RefObject<AgGridReact<PUR6010_R01DetailDto> | null>;

	tabList: Tab[] | undefined;
	setMessage: (message: string) => void;

	containerRef: React.RefObject<HTMLDivElement | null>;
	isResizing: React.MutableRefObject<boolean>;
	
}



export const Content_PUR6010_R01 = (props: Props) => {

	const {
		gridRef, detailGridRef,
		tabList, setMessage,
		containerRef,
		isResizing,
	} = props;

	const { moneyCdList, vatTypeList, compCdList, customCdList, employeeCdList } = useCommonCodeStore();

	
	const {
		PUR6010_R01Filter, setPUR6010_R01Filter,
		PUR6010_R01PastFilter, setPUR6010_R01PastFilter,
		PUR6010_R01List, setPUR6010_R01List,
		editPUR6010_R01, setEditPUR6010_R01,
		selectedPUR6010_R01, setSelectedPUR6010_R01, 
		deletedPUR6010_R01DetailList, setDeletedPUR6010_R01DetailList, addDeletedPUR6010_R01DetailList, removeDeletedPUR6010_R01DetailList, 
		selectedPUR6010_R01DetailList, setSelectedPUR6010_R01DetailList, addSelectedPUR6010_R01DetailList, removeSelectedPUR6010_R01DetailList,
		PUR6010_R01DetailList, setPUR6010_R01DetailList, insertPUR6010_R01DetailList,
		originalPUR6010_R01DetailList, setOriginalPUR6010_R01DetailList,
		allCount, setAllCount,
		detailFetchTrigger, setDetailFetchTrigger,
		detailCreateTrigger, setDetailCreateTrigger,
		initData,
		setScrollTop, setDetailScrollTop,
	} = usePUR6010_R01Store();
	const { setLoadingSpinner } = useLoadingSpinnerStore();
	const createDetailFetchingRef = useRef(false);

	useFetchActionbarAuth("PUR6010_R01");
	

	const handleExcelClick = useCallback(async () => {
		if (!selectedPUR6010_R01) {
			showWarning("선택된 지불내역내역이 없습니다.");
			return;
		}
		setLoadingSpinner(true);

		const { isDefaultFilter, isDefaultPastFilter, listLength } = fetchFilterConfig(
			PUR6010_R01Filter,
			PUR6010_R01PastFilter,
			defaultPUR6010_R01Filter,
			PUR6010_R01List.length
		);

		const response = await downloadExcel_PUR6010_R01(isDefaultFilter? '' : 'search', selectedPUR6010_R01.paymentNo, listLength);

		downloadSettingExcel({ responseData: response.data.data, fileName: '지불내역 등록-excel.xlsx' });

		setLoadingSpinner(false);
	}, [selectedPUR6010_R01])

	const getParams = (filter: PUR6010_R01Filter) => {
		const params: Partial<PUR6010_R01Filter> = {
			paymentDateRange: filter.paymentDateRange || undefined,
			tradeDateRange: filter.tradeDateRange || undefined,
			customCd: filter.customCd || undefined,
			compCd: filter.compCd || undefined,
			compNm: filter.compNm || undefined,
			tradeType: filter.tradeType || undefined,
		};
		return params;
	}

	const renewalAllCount = useCallback(async () => {
		const response = await getPUR6010_R01AllCount(getParams(PUR6010_R01Filter));
		setAllCount(response.data.data);
		return response.data.data;
	}, [PUR6010_R01Filter, setAllCount]);

	const fetchData = useCallback(async () => {
		setScrollTop(null);
		setDetailScrollTop(null);
		setLoadingSpinner(true);		
	
		const responseData = (await getPUR6010_R01List(
			'',
			getParams(PUR6010_R01Filter),
			PUR6010_R01List.length ?? 0
		));


		let newList = [...responseData.data.data] as PUR6010_R01HeaderDto[];
		setPUR6010_R01List(newList);

		const processAllCount = await renewalAllCount();
		if (newList && newList.length > 0) {
			gridRefSelectedRowHandler(
				gridRef,
				setSelectedPUR6010_R01,
				() => true,// () => !responseData.find(value => value.salBillNo === selectedPUR6010_R01?.salBillNo)
			);
			setPUR6010_R01PastFilter(PUR6010_R01Filter);
			ShowSuccessFetch(setMessage, `조회가 완료되었습니다. (총 ${newList.length}/${processAllCount}건)`);
			setTimeout(() => setMessage(""), 5000);
		}else {
			showWarning('데이터가 없습니다.');
			setSelectedPUR6010_R01(undefined);
			setPUR6010_R01List([]);
			setPUR6010_R01DetailList([]); 
			setDeletedPUR6010_R01DetailList([]);
			setSelectedPUR6010_R01DetailList([]);
			setOriginalPUR6010_R01DetailList([]);
		}
		setLoadingSpinner(false);
		return responseData;
	}, [PUR6010_R01Filter, PUR6010_R01List, setPUR6010_R01List, setPUR6010_R01PastFilter, setSelectedPUR6010_R01, selectedPUR6010_R01, setScrollTop, setDetailScrollTop])

	const defaultPUR6010_R01HeaderRow = useCallback(() => {
		return {
			...defaultPUR6010_R01HeaderDto,
			compCd: compCdList[0].compCd,
			moneyCd: moneyCdList[0].minorCd,
			inserted: true,
		}
	}, [defaultPUR6010_R01HeaderDto, compCdList]);

	const defaultPUR6010_R01DetailRow = useCallback(() => {
		return {
			...defaultPUR6010_R01DetailDto,
			inserted: true,
		}
	}, [defaultPUR6010_R01DetailDto, compCdList, ]);
	
	const initContainerData = useCallback(() => {
		initData();
		removeDeletedPUR6010_R01DetailList();
		removeSelectedPUR6010_R01DetailList();
		setEditPUR6010_R01({ ...defaultPUR6010_R01HeaderRow(), })
	}, [defaultPUR6010_R01HeaderRow, selectedPUR6010_R01])

	const handleCreateClick = useCallback(() => {
		setDetailCreateTrigger(false);
		setSelectedPUR6010_R01(undefined);
		setEditPUR6010_R01({ ...defaultPUR6010_R01HeaderRow(), })
		setPUR6010_R01DetailList([]);
		setDeletedPUR6010_R01DetailList([]);
		setSelectedPUR6010_R01DetailList([]);
		setOriginalPUR6010_R01DetailList([]);
		setDetailScrollTop(null);
	}, [
		defaultPUR6010_R01HeaderRow,
		setDetailCreateTrigger,
		setSelectedPUR6010_R01,
		setEditPUR6010_R01,
		setPUR6010_R01DetailList,
		setDeletedPUR6010_R01DetailList,
		setSelectedPUR6010_R01DetailList,
		setOriginalPUR6010_R01DetailList,
		setDetailScrollTop,
	]);

	const handleDeleteClick = useCallback(async () => {
		if (!selectedPUR6010_R01) {
			showWarning('선택된 지불내역이 없습니다.');
			return;
		}

		if (!window.confirm('정말로 삭제하시겠습니까?')) {
			return;
		}

		await deletePUR6010_R01(selectedPUR6010_R01.paymentNo);
		refetchUpdateList('delete', defaultPUR6010_R01HeaderRow(), selectedPUR6010_R01, 'tradeNo', PUR6010_R01List, setPUR6010_R01List);
		handleCreateClick();
		showSuccess(`${selectedPUR6010_R01.tradeNo || selectedPUR6010_R01.paymentNo} 지불내역 삭제가 완료되었습니다.`);
	}, [
		selectedPUR6010_R01,
		defaultPUR6010_R01HeaderRow,
		PUR6010_R01List,
		setPUR6010_R01List,
		handleCreateClick,
	]);

	const validateInsertData = (header: PUR6010_R01HeaderDto, detailList: PUR6010_R01DetailDto[]) => {
		
		if (!validateString(header.compCd)) {
			showWarning('사업장을 선택해주세요.'); return false;
		}
		if (!validateString(header.customCd)) {
			showWarning('거래처를 입력해주세요.'); return false;
		}
		if (!validateCustomCd(header.customCd, customCdList)) {
			showWarning('거래처가 존재하지 않습니다.(입력칸을 더블클릭하거나 엔터키로 세부사항을 열어서 지정해주세요)'); return false;
		}
		if(!validateString(header.empNo)) {
			showWarning('담당자를 선택해주세요.'); return false;
		}
		if (!validateEmployeeCd(header.empNo, employeeCdList)) {
			showWarning('담당자가 존재하지 않습니다.(입력칸을 더블클릭하거나 엔터키로 세부사항을 열어서 지정해주세요)'); return false;
		}

		if (Number(header.noteAmt ?? 0) > 0) {
			const issueDate = formatDateYYYYMMDD(header.issueDt);
			const dueDate = formatDateYYYYMMDD(header.dueDt);
			if (!issueDate || !dueDate) {
				showWarning('어음금액이 있을 경우 발행일과 만기일을 입력해주세요.'); return false;
			}
			if (dueDate < issueDate) {
				showWarning('어음만기일은 어음발행일보다 같거나 커야 합니다.'); return false;
			}
		}

		// if (!validateString(header.tradeNo)) {
		// 	const deletedDetailIndexList = deletedPUR6010_R01DetailList.map(value => Number(value));
		// 	const checkedDetailCount = detailList.filter(
		// 		detail => !deletedDetailIndexList.includes(detail.valueIndex) && detail.checkProcess === 'Y',
		// 	).length;
		// 	if (checkedDetailCount <= 0) {
		// 		showWarning('처리할 상세내역을 선택해주세요.'); return false;
		// 	}

		// 	const activeDetailList = filterDeletedItems(detailList, deletedPUR6010_R01DetailList);

		// 	for (const detail of activeDetailList) {
		// 		if (!validateString(detail.itemNo)) continue;

		// 		const otherDetailList = activeDetailList.filter(d =>
		// 			(detail.valueIndex != null && d.valueIndex !== detail.valueIndex) ||
		// 			(detail.valueIndex == null && d !== detail)
		// 		);
		// 		if (otherDetailList.some(d => d.itemNo === detail.itemNo)) {
		// 			showWarning("중복된 항목번호가 있습니다.\n항목번호: " + detail.itemNo);
		// 			return false;
		// 		}
		// 	}
		// }

		return true;
	}

	const setInfoDetailList = useCallback((header: PUR6010_R01HeaderDto, detailList: PUR6010_R01DetailDto[]) => {
		
		return detailList.map((value, idx) => ({
			...value,
			compCd: header.compCd,
			customCd: header.customCd,
		}))
	}, [setPUR6010_R01DetailList])
	
	const handleSaveClick = useCallback(async () => {

		let valid = true;
		if(!validateInsertData(editPUR6010_R01!, PUR6010_R01DetailList)) valid = false;
		if(!valid) { return; }
		
		const deletedPUR6010_R01DetailList_Number = deletedPUR6010_R01DetailList.map(value => Number(value));
		let processName = '';
		let newDetailList: PUR6010_R01DetailDto[] = [];
		let newHeaderList: PUR6010_R01HeaderDto[] = [];
		let responseData: PUR6010_R01Dto = {
			purPaymentHeaderDto: editPUR6010_R01!,
			purPaymentDetailDtoList: PUR6010_R01DetailList
		};

		if (selectedPUR6010_R01) {
			newDetailList = PUR6010_R01DetailList.filter(value => 
				!deletedPUR6010_R01DetailList_Number.includes(value.valueIndex)
			);

			processName = 'patch';
			const patchResponse = await patchPUR6010_R01({
				purPaymentHeaderDto: editPUR6010_R01!,
				purPaymentDetailDtoList: setInfoDetailList(editPUR6010_R01!, newDetailList)
			});

			responseData = patchResponse.data.data[0];
			newHeaderList = PUR6010_R01List.map(value => {
				if (value.tradeNo === responseData.purPaymentHeaderDto.tradeNo) {
					return responseData.purPaymentHeaderDto;
				}
				return value;
			});
			
			if (patchResponse?.data?.data?.[0] && patchResponse.data.successFlag) {

				showSuccess('지불내역 수정에 성공하였습니다.');
				setMessage('지불내역 수정에 성공하였습니다.');
			}else {
				// 서버 응답이 예상과 다를 경우의 에러 처리
				showWarning('지불내역 수정 후 서버로부터 올바른 데이터를 받지 못했습니다.');
				return;
			}
		} else {
			processName = 'post';
			const activeDetailList = PUR6010_R01DetailList.filter(value =>
				!deletedPUR6010_R01DetailList_Number.includes(value.valueIndex) && value.checkProcess === 'Y',
			);
			const postResponse = await postPUR6010_R01({
				purPaymentHeaderDto: editPUR6010_R01!,
				purPaymentDetailDtoList: setInfoDetailList(editPUR6010_R01!, activeDetailList),
			});

			responseData = postResponse.data.data[0];
			newHeaderList = [
				...PUR6010_R01List,
				responseData.purPaymentHeaderDto,
			] as PUR6010_R01HeaderDto[];

			if (postResponse?.data?.data?.[0] && postResponse.data.successFlag) {
				showSuccess('지불내역 등록에 성공하였습니다.');
				setMessage('지불내역 등록에 성공하였습니다.');
			} else {
				showWarning('지불내역 등록 후 서버로부터 올바른 데이터를 받지 못했습니다.');
				return;
			}
		}


		if (processName === 'delete') {
			setPUR6010_R01List(newHeaderList);
			setSelectedPUR6010_R01(undefined);
			setPUR6010_R01DetailList([]);
			handleCreateClick();
		}else if (processName === 'patch' || processName === 'post') {
			setPUR6010_R01List(newHeaderList);
			setPUR6010_R01DetailList(responseData.purPaymentDetailDtoList);
			
			setSelectedPUR6010_R01(responseData.purPaymentHeaderDto);
			setOriginalPUR6010_R01DetailList(responseData.purPaymentDetailDtoList);
		}

		// setSelectedPUR6010_R01(undefined);
		setDeletedPUR6010_R01DetailList([]);
		setSelectedPUR6010_R01DetailList([]); // 저장 후 상세행 선택 상태 초기화
		setTimeout(() => {
			setMessage('');
		}, 5000)
	
	}, [
		editPUR6010_R01, 
		selectedPUR6010_R01, 
		PUR6010_R01DetailList, 
		deletedPUR6010_R01DetailList, 
		PUR6010_R01List, setPUR6010_R01List
	])

	const fetchOne = useCallback(async () => {
		if (!selectedPUR6010_R01?.tradeNo) return;
		setLoadingSpinner(true);
		try {
			const response = await getPUR6010_R01One(selectedPUR6010_R01.tradeNo);
			setEditPUR6010_R01(response.data.data as PUR6010_R01HeaderDto);
		} catch (error) {
			console.error("조회 중 오류 발생:", error);
			showError("조회 중 오류가 발생했습니다.");
		}
		setLoadingSpinner(false);
	}, [selectedPUR6010_R01, setEditPUR6010_R01, setLoadingSpinner]);

	const fetchDetailList = useCallback(async (tradeNo: string) => {
		if (!detailFetchTrigger) return;
		setDetailScrollTop(null);

		(detailGridRef.current as any)?.clearRange?.();

		const responseData = (await getPUR6010_R01DetailList(tradeNo)).data.data;
		if(responseData && responseData.length > 0){
			setPUR6010_R01DetailList(responseData.map((value, idx) => ({
				...value,
				valueIndex: value.valueIndex ?? idx + 1,
				orderIndex: value.orderIndex ?? idx + 1,
				orderIndexSeq: value.orderIndexSeq ?? 0,
			})));
			setOriginalPUR6010_R01DetailList(responseData);
			setMessage(`${selectedPUR6010_R01?.customNm}의 지불내역내역 ${responseData.length}건을 조회하였습니다.`);
			setTimeout(() => setMessage(""), 5000);
		}else{
			showError('상세내역이 없습니다.');
			setPUR6010_R01DetailList([]);
			insertPUR6010_R01DetailList([{ ...defaultPUR6010_R01DetailRow() }])
		}
		setDetailFetchTrigger(false);
	}, [
		detailFetchTrigger,
		setDetailScrollTop,
		detailGridRef,
		setPUR6010_R01DetailList,
		setOriginalPUR6010_R01DetailList,
		selectedPUR6010_R01?.customNm,
		setMessage,
		insertPUR6010_R01DetailList,
		defaultPUR6010_R01DetailRow,
		setDetailFetchTrigger,
	])

	const fetchCreateDetailList = useCallback(async (customCd: string) => {
		const { detailCreateTrigger } = usePUR6010_R01Store.getState();
		if (!detailCreateTrigger || !customCd || createDetailFetchingRef.current) return;

		createDetailFetchingRef.current = true;
		setDetailCreateTrigger(false);
		setDetailScrollTop(null);

		(detailGridRef.current as any)?.clearRange?.();

		try {
			const responseData = (await getPUR6010_R01CreateDetailList(customCd, PUR6010_R01Filter.tradeDateRange)).data.data;
			if(responseData && responseData.length > 0){
				setPUR6010_R01DetailList(responseData.map((value, idx) => ({
					...value,
					valueIndex: value.valueIndex ?? idx + 1,
					orderIndex: value.orderIndex ?? idx + 1,
					orderIndexSeq: value.orderIndexSeq ?? 0,
					inserted: true,
				})));
				setOriginalPUR6010_R01DetailList([]);
				setMessage(`등록용 지불내역 ${responseData.length}건을 조회하였습니다.`);
				setTimeout(() => setMessage(""), 5000);
			}else{
				showError('등록용 지불내역을 찾을 수 없습니다');
				setPUR6010_R01DetailList([]);
			}
		} finally {
			createDetailFetchingRef.current = false;
			setDetailCreateTrigger(false);
		}
	}, [
		PUR6010_R01Filter.tradeDateRange,
		setDetailScrollTop,
		detailGridRef,
		setPUR6010_R01DetailList,
		setOriginalPUR6010_R01DetailList,
		setMessage,
		insertPUR6010_R01DetailList,
		defaultPUR6010_R01DetailRow,
		setDetailCreateTrigger,
	])

	useEffect(() => {
		if (detailCreateTrigger && editPUR6010_R01?.customCd) {
			fetchCreateDetailList(editPUR6010_R01.customCd);
		}
	}, [detailCreateTrigger, editPUR6010_R01?.customCd, fetchCreateDetailList])

	useEffect(() => {
		if (selectedPUR6010_R01) {
			fetchOne();
			// fetchDetailList(selectedPUR6010_R01.tradeNo!)
		}
	}, [selectedPUR6010_R01, fetchOne, fetchDetailList])
	
	return {
		handleExcelClick,
		fetchData,
		defaultPUR6010_R01HeaderRow,
		defaultPUR6010_R01DetailRow,
		initContainerData,
		handleDeleteClick,
		handleCreateClick,
		handleSaveClick,
	};
}
